import { render, staticRenderFns } from "./RoomNotice.vue?vue&type=template&id=295ef5ed&"
import script from "./RoomNotice.vue?vue&type=script&lang=js&"
export * from "./RoomNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295ef5ed')) {
      api.createRecord('295ef5ed', component.options)
    } else {
      api.reload('295ef5ed', component.options)
    }
    module.hot.accept("./RoomNotice.vue?vue&type=template&id=295ef5ed&", function () {
      api.rerender('295ef5ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/ExtendMenu/RoomNotice/RoomNotice.vue"
export default component.exports